import { useEffect, useContext } from 'react';
import { useNavigate } from 'react-router';
import { constructNow, isAfter } from 'date-fns';
import useSWR from 'swr';
import { AuthContext } from '../../context/AuthContext';
import { useUnityGameStatus } from '../game/yaong-egg/GameProviderEgg.jsx';
import { ReactComponent as ArrowIcon } from '../../assets/icons/arrow_left.svg';
import ShineGreen from '../../assets/images/pool_event/shine-green.png';
import ShineOrange from '../../assets/images/pool_event/shine-orange.png';
import Prize01 from '../../assets/images/pool_event/prize_01.png';
import Prize02 from '../../assets/images/pool_event/prize_02.png';
import Prize03 from '../../assets/images/pool_event/prize_03.png';
import Prize04 from '../../assets/images/pool_event/prize_04.png';
import Prize05 from '../../assets/images/pool_event/prize_05.png';
import Prize06 from '../../assets/images/pool_event/prize_06.png';
import Character from '../../assets/images/pool_event/character.png';
import Checkmark from '../../assets/images/pool_event/checkmark.png';
import Diamond from '../../assets/images/pool_event/diamond.png';
import ArrowRight from '../../assets/images/pool_event/arrow-right.png';

export default function EventDetails() {
  const navigate = useNavigate();
  const { isFullyReady, showInModal, setShowInModal, setGameMode } = useUnityGameStatus();
  const { API_SERVER_DOMAIN, useAccessToken, fetchWithToken } = useContext(AuthContext);
  const accessToken = useAccessToken();
  const { data: weeklyFeed } = useSWR(
    accessToken && [`${API_SERVER_DOMAIN}/pool/event/userWeeklyFeed`, accessToken],
    fetchWithToken,
  );

  useEffect(() => {
    document.getElementsByClassName('page-container')[0]?.scrollTo(0, 0);
  }, []);

  if (!weeklyFeed) return null;

  return (
    <section className="pool-event-details">
      <div className="pool-event-header">
        <ArrowIcon onClick={() => navigate(-1)} />
      </div>
      <div className="pool-event-contents">
        <div className="pool-event-title">
          <div className="pool-event-title-banner">
            <h3>야옹상회</h3>
            <h4>“송추히든밸리”수영장 무료 이벤트</h4>
          </div>
          <div className="pool-event-title-text">
            <p>간식 5회 이상 주면 자동 응모 완료!</p>
            <p>간식 많이 줄수록 당첨 확률 UP!</p>
          </div>
        </div>

        <div className="pool-event-subtitle">
          <img src={ShineGreen} alt="이벤트 상품" />
          <span>이벤트 상품</span>
        </div>

        <div className="pool-event-prize">
          <img src={Prize01} alt="이벤트 상품" />
          <img src={Prize02} alt="이벤트 상품" />
          <img src={Prize03} alt="이벤트 상품" />
          <img src={Prize04} alt="이벤트 상품" />
          <img src={Prize05} alt="이벤트 상품" />
          <img src={Prize06} alt="이벤트 상품" />
        </div>

        <div className="pool-event-subtitle">
          <img src={ShineGreen} alt="간식 주고 응모하기!" />
          <span>간식 주고 응모하기!</span>
        </div>

        <div className="pool-event-character">
          <img src={Character} alt="캐릭터" />
        </div>

        <div
          className="pool-event-link"
          onClick={() => {
            /* alert(
              '이벤트 페이지 내 [간식 주기] 기능은 현재 점검 중입니다.\n놀이터 > 간식 타이밍 맞추기에서 정상적으로 이용하실 수 있습니다.\n빠르게 복구하겠습니다. 감사합니다.',
            );
            return; */
            if (isAfter(constructNow(), new Date('2025-08-10'))) {
              alert('이벤트 기간이 아니에요.');
              return;
            }
            if (isFullyReady) {
              setGameMode('');
              setShowInModal(true);
            }
          }}
        >
          <span>간식주기</span>
          <svg width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              className="svg-path-animated-1"
              d="M6.45543 6.67152L6.37005 6.77305L2.2555 11.0938C2.07039 11.2875 1.82199 11.4 1.56077 11.4083C1.29955 11.4167 1.04509 11.3204 0.849063 11.1389C0.653041 10.9574 0.530158 10.7043 0.505375 10.4311C0.480591 10.1579 0.555765 9.88503 0.715627 9.66793L0.801004 9.56639L4.18728 6.00937L0.801004 2.45235C0.623897 2.26635 0.517503 2.01889 0.501785 1.75637C0.486066 1.49386 0.562101 1.23435 0.715627 1.02652L0.801004 0.924984C0.978128 0.739003 1.21379 0.627279 1.46377 0.610773C1.71376 0.594267 1.96089 0.674112 2.15881 0.83533L2.2555 0.924984L6.37005 5.24569C6.54716 5.43168 6.65355 5.67915 6.66927 5.94166C6.68499 6.20417 6.60895 6.46369 6.45543 6.67152Z"
              fill="white"
              fillOpacity="0.35"
            />
          </svg>
          <svg width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              className="svg-path-animated-2"
              d="M6.45543 6.67152L6.37005 6.77305L2.2555 11.0938C2.07039 11.2875 1.82199 11.4 1.56077 11.4083C1.29955 11.4167 1.04509 11.3204 0.849063 11.1389C0.653041 10.9574 0.530158 10.7043 0.505375 10.4311C0.480591 10.1579 0.555765 9.88503 0.715627 9.66793L0.801004 9.56639L4.18728 6.00937L0.801004 2.45235C0.623897 2.26635 0.517503 2.01889 0.501785 1.75637C0.486066 1.49386 0.562101 1.23435 0.715627 1.02652L0.801004 0.924984C0.978128 0.739003 1.21379 0.627279 1.46377 0.610773C1.71376 0.594267 1.96089 0.674112 2.15881 0.83533L2.2555 0.924984L6.37005 5.24569C6.54716 5.43168 6.65355 5.67915 6.66927 5.94166C6.68499 6.20417 6.60895 6.46369 6.45543 6.67152Z"
              fill="white"
              fillOpacity="0.35"
            />
          </svg>
          <svg width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              className="svg-path-animated-3"
              d="M6.45543 6.67152L6.37005 6.77305L2.2555 11.0938C2.07039 11.2875 1.82199 11.4 1.56077 11.4083C1.29955 11.4167 1.04509 11.3204 0.849063 11.1389C0.653041 10.9574 0.530158 10.7043 0.505375 10.4311C0.480591 10.1579 0.555765 9.88503 0.715627 9.66793L0.801004 9.56639L4.18728 6.00937L0.801004 2.45235C0.623897 2.26635 0.517503 2.01889 0.501785 1.75637C0.486066 1.49386 0.562101 1.23435 0.715627 1.02652L0.801004 0.924984C0.978128 0.739003 1.21379 0.627279 1.46377 0.610773C1.71376 0.594267 1.96089 0.674112 2.15881 0.83533L2.2555 0.924984L6.37005 5.24569C6.54716 5.43168 6.65355 5.67915 6.66927 5.94166C6.68499 6.20417 6.60895 6.46369 6.45543 6.67152Z"
              fill="white"
              fillOpacity="0.35"
            />
          </svg>
        </div>

        <div className="pool-event-status">
          <div className="pool-event-status-item-1">
            <div className="pool-event-status-label">
              <img src={ShineOrange} alt="데코" />
              <span>이번주 내가 준 간식 현황</span>
            </div>
            <div className="pool-event-status-count">
              <span>{weeklyFeed.infos.count}</span>
              <span>개</span>
            </div>
          </div>
          <div className="pool-event-status-item-2">
            <img src={Checkmark} alt="체크" />
            <span>{weeklyFeed.infos.count >= 5 ? '간식 응모 진행 중!' : '간식 5회 이상 줘야 응모가 시작돼요.'}</span>
          </div>
        </div>

        <div className="pool-event-description">
          <div className="pool-event-orange-line">
            <div></div>
          </div>
          <div className="pool-event-description-item-1">
            <div className="item-1-subtitle">
              <img src={Diamond} alt="다이아몬드" />
              <span>응모 방식 및 추첨 안내</span>
            </div>
            <ul>
              <li>
                부화냥에게 간식을 <b>5회 이상</b> 주면 <b>자동으로 응모돼요.</b>
              </li>
              <li>
                <b>응모 자격은 매주 리셋</b>되며, 매주 새로운 추첨이 진행돼요.
              </li>
              <li>
                <b>간식을 많이 줄수록 당첨 확률이 올라가요!</b>
              </li>
              <li>
                <b>당첨자는 ‘My &gt; 쿠폰’ 메뉴를 통해 상품 확인이 가능 해요.</b>
              </li>
            </ul>
          </div>
          <div
            className="pool-event-description-item-2"
            onClick={() => {
              navigate('/pool/prizewinner');
            }}
          >
            <span>당첨자 확인하러 가기</span>
            <img src={ArrowRight} alt="이동하기" />
          </div>
          <div className="pool-event-dotted-line"></div>
          <div className="pool-event-description-item-3">
            <ul>
              <li>
                <div className="pool-event-pill-box">추첨 발표일</div>
                <div className="pill-box-desc">매주 월요일 오후 1시</div>
              </li>
              <li>
                <div className="pool-event-pill-box">당첨 인원</div>
                <div className="pill-box-desc">매주 100명 (순위별 상품 차등 지급)</div>
              </li>
              <li>
                <div className="pool-event-pill-box">이벤트 기간</div>
                <div className="pill-box-desc">2025.07.14 ~ 08.10</div>
              </li>
              <li className="pool-event-footnote">
                ※ 매주 일요일 밤 12시까지 부화냥에게 간식을 준 유저만 해당 주 추첨 대상
              </li>
              <li>
                <div className="pool-event-pill-box">상품 유효기간</div>
                <div className="pill-box-desc">
                  <b>지급일로부터 3주 이내 사용 가능</b>
                </div>
              </li>
            </ul>
          </div>
          <div className="pool-event-orange-line">
            <div></div>
          </div>
          <div className="pool-event-description-item-4">
            <div className="item-4-subtitle">
              <span>&bull;</span> 유의 사항
            </div>
            <ul>
              <li>
                <span>✅</span>
                <span className="item-4-spacer">-</span>
                <span>간식은 [놀이터 &gt; 간식충전소]에서 광고 시청을 통해 충전할 수 있어요.</span>
              </li>
              <li>
                <span className="item-4-hidden">✅</span>
                <span className="item-4-spacer">-</span>
                <span>[간식 타이밍 맞추기]에서 간식을 5회 이상 주면 자동으로 응모돼요.</span>
              </li>
              <li>
                <span className="item-4-hidden">✅</span>
                <span className="item-4-spacer">-</span>
                <span>
                  중복 당첨은 불가하며, 한 주당 1회만 당첨될 수 있으며, 다음 주에 다시 간식을 주면 자동으로 재응모돼요.
                </span>
              </li>
              <li>
                <span className="item-4-hidden">✅</span>
                <span className="item-4-spacer">-</span>
                <span>
                  당첨자는 매주 월요일, 이벤트 페이지의 [당첨자 확인 하러가기 →]에서 확인할 수 있으며, 당첨자에게만 당첨
                  팝업이 노출돼요.
                </span>
              </li>
              <li>
                <span className="item-4-hidden">✅</span>
                <span className="item-4-spacer">-</span>
                <span>
                  포인트는 야옹상회 앱 내에서 즉시 지급되며, 이외 지급된 상품은 [MY &gt; 쿠폰] 메뉴에서 확인할 수
                  있어요.
                </span>
              </li>
              <li>
                <span>✅</span>
                <span className="item-4-spacer">-</span>
                <span>포인트를 제외한 실물 상품은 [히든밸리 송추 수영장]직원에게 보여주고 사용 처리해야 해요.</span>
              </li>
              <li>
                <span>✅</span>
                <span className="item-4-spacer">-</span>
                <span>동일 등수의 유저가 여러 명일 경우, 재 추첨을 통해 무작위 1명이 선정돼요.</span>
              </li>
              <li>
                <span>✅</span>
                <span className="item-4-spacer">-</span>
                <span>
                  평상 및 입장권 무료 쿠폰은 [야옹상회]에서 평상 예약 시 직접 적용되지 않으며, 주간 또는 야간만 사용
                  가능 해요.
                </span>
              </li>
              <li>
                <span className="item-4-hidden">✅</span>
                <span className="item-4-spacer">-</span>
                <span>예약을 먼저 완료하신 후, 현장 매표소에서 쿠폰을 제시 하면 환급 처리 해드려요!</span>
              </li>
              <li>
                <span>✅</span>
                <span className="item-4-spacer">-</span>
                <span>
                  이벤트 상품은 타인에게 양도하거나 거래할 수 없으며, 부정한 방법으로 획득/참여한 경우 당첨이 취소될 수
                  있어요.
                </span>
              </li>
              <li>
                <span>✅</span>
                <span className="item-4-spacer">-</span>
                <span>이벤트는 회사 사정에 따라 사전 고지 없이 변경되거나 조기 종료될 수 있어요.</span>
              </li>
              <li>
                <span>✅</span>
                <span className="item-4-spacer">-</span>
                <span>상품 구성은 상황에 따라 변경될 수 있어요.</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
